module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAA80lEQVRIS+2Wv04CQRCHv5+d8QH0BZSGAnqegIbXsLEjwcJAi9fZaXgJamoTS20EOjqRlsRgoz+y5oqLUe9O7goIm2yzO5lvZnbnj2x3gXPgBBDFLAOvwK1svwBT4Bl4K0Y/R0AVqATAJxBJuixI+Zca2xHQDoDgznUJgD7Q2WGA7TOgmfFdRpLGSVnbf4fI9iNQywh4klTPCzgEWt8AV8AKGADLxN1Q0nsuwE+W274P55IaaZ6lhmgP2Idoe3/RA/BRZh5cAAeSbkpJtDSlG5eK/wJKb5lzYALM4kqZx9DfZEMlPg07tMxePLYcFzy2LIC7NSG5CZVFKi83AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/canvasImg/panel/wenben1@2x.png
// module id = kkET
// module chunks = 14